import React from 'react';
import { Virtuoso } from 'react-virtuoso';
import moment from 'moment';

import NotFoundDoctor from 'src/assets/images/notfound-doctor.png';

import { DatePickerField, MCButton, MCText, Spinner, ToggleSwitch } from 'src/components/basic';
import BaseComponent from 'src/components/BaseComponent';

import {
  addressObject,
  lang,
  objectToSelectList,
  permissions,
  remCss,
  userFullName,
  withRouter
} from 'src/helpers';

import { DoctorItem } from './components/DoctorItem';
import model from './model';
import PopupSelect from 'src/components/complex/popupSelect';
import LANG_CONST from 'src/helpers/lang/const';
import { Categories } from 'src/components/doctor/Categories';
import ShortInfo from 'src/components/user/ShortInfo';

const Header = () => {
  model.use();

  const searchQuery = model.listInput('search');

  const chooseSpecialist = (selected) => {
    if (selected?._isSpecialist) {
      model.listHandleChange('search', '');
      model.setListStateSilent({ items: [] }, 'search');
      document.querySelectorAll('#mc-categories pre').forEach((item) => {
        if (item.innerHTML === selected.label)
          item.scrollIntoView({
            behavior: 'auto',
            block: 'center',
            inline: 'center'
          });
      });
      selected = selected.value;
    }
    const value = model.input('specialist').includes(selected) ? [] : [selected];
    model.handleChange('specialist', value);
    model.refresh();
  };

  return (
    <>
      <Categories
        showAllWhenNotSelected={false}
        specialist={Object.keys(LANG_CONST.constants.specialist)}
        onClick={chooseSpecialist}
        selected={model.input('specialist')}
      />
      <div className={'mc-container-content__header mc-flex-20 mc-mt20'}>
        <span>{lang.t(LANG_CONST.titles.doctors)}</span>
        <div className='mc-appointment-types'>
          {Object.keys(LANG_CONST.constants.appointment_types).map((id) => {
            const isActive = model.input('appointmentTypes').includes(id);
            return (
              <div key={id} className='mc-appointment-types__item'>
                <MCText size={20}>{LANG_CONST.constants.appointment_types[id]}</MCText>
                <ToggleSwitch
                  keyId={id}
                  checked={isActive}
                  onChange={() => {
                    let appointmentTypes = model.input('appointmentTypes');
                    if (isActive && appointmentTypes.length > 1) {
                      model.handleChange(
                        'appointmentTypes',
                        appointmentTypes.filter((v) => v !== id)
                      );
                      model.refresh();
                    } else if (!isActive) {
                      model.handleChange('appointmentTypes', [...appointmentTypes, id]);
                      model.refresh();
                    }
                  }}
                />
              </div>
            );
          })}
        </div>
        {/*<MCText textLight size={13}>*/}
        {/*  {lang.t('Showing')}{': '}*/}
        {/*  {model*/}
        {/*    .input('appointmentTypes')*/}
        {/*    .map((id) => LANG_CONST.constants.appointment_types[id])*/}
        {/*    .join(' + ')}*/}
        {/*</MCText>*/}

        <div className={'mc-grow'} />
        <div className={'mc-flex-15 mc-wrap'}>
          <PopupSelect
            isPopover={true}
            defaultValue={false}
            isClearable={true}
            placeholderTxt={
              searchQuery ? (
                <span className={`mc-text-418`}>{searchQuery}</span>
              ) : (
                lang.t(LANG_CONST.text.search)
              )
            }
            apiConfig={{
              url: 'clinic/doctor/all',
              available: true,
              labelFn: (user) => (
                <ShortInfo
                  user={user}
                  specialist={[]}
                  fullname={userFullName(user, !user?._isSpecialist)}
                />
              )
            }}
            onChange={(n, v, data) => {
              // search query
              if (!v) {
                model.handleChangeSearch('');
              } else if (data.item?._isSpecialist) {
                // search specialist
                model.listHandleChange('search', '');
                chooseSpecialist(data.item);
              } else {
                // search doctor
                const query = userFullName(data.item, true);
                model.setListStateSilent({ searchDoctor: { id: data.value, query } }, 'search');
                model.handleChangeSearch(query);
              }
            }}
            canProcess={({ query }) => {
              query = query?.toString().replace(/[+*]+/g, '').trim().toLowerCase() || '';
              let querySplits = query.split(' ');
              if (
                querySplits[0] === 'doctor' ||
                querySplits[0] === 'dr' ||
                querySplits[0] === 'dr.'
              ) {
                querySplits.splice(0, 1);
              }
              return querySplits.join('').length > 2;
            }}
            onKeyDown={(e, hide) => {
              if (e.key === 'Enter') {
                e.preventDefault();
                hide();
                model.handleChangeSearch(e.target.value || '');
              }
            }}
            expandOptionsFn={(text) => {
              return text
                ? objectToSelectList(LANG_CONST.constants.specialist, true)
                    .filter((item) => item.label.toLowerCase().indexOf(text.toLowerCase()) > -1)
                    .map((item) => ({
                      ...item,
                      id: item.value,
                      firstName: item.label,
                      _isSpecialist: true
                    }))
                : [];
            }}
            template={5}
            styles={{
              backgroundColor: '#fff',
              width: remCss(300),
              maxWidth: remCss(300)
            }}
          />
          <PopupSelect
            template={5}
            styles={{
              backgroundColor: '#fff',
              width: remCss(200),
              maxWidth: remCss(200)
            }}
            placeholder={LANG_CONST.address.city}
            apiConfig={{
              url: 'hospital/cities',
              valueKey: 'city',
              labelFn: (item) =>
                addressObject({
                  cityAddress: item.city,
                  stateAddress: item.state,
                  countryAddress: item.country
                }).fullAddressNameReverse
            }}
            isPopover={true}
            defaultValue={false}
            name={'cityAddress'}
            value={model.input('cityAddress')}
            onChange={(n, v) => {
              if (v?.toString() === model.input('cityAddress')?.toString()) return;
              model.handleChange(n, v);
              model.handleChange('hospital', '');
              model.refresh();
            }}
          />
          {!!model.input('cityAddress') && (
            <PopupSelect
              template={5}
              styles={{
                backgroundColor: '#fff',
                width: remCss(200),
                maxWidth: remCss(200)
              }}
              isPopover={true}
              defaultValue={false}
              apiConfig={{
                url: 'hospital/all',
                valueKey: 'hospital',
                labelFn: (i) => i.hospital?.split('_')[0],
                city: model.input('cityAddress')
              }}
              placeholder={LANG_CONST.hospital}
              name={'hospital'}
              value={model.input('hospital')}
              onChange={(n, v) => {
                if (v?.toString() === model.input('hospital')?.toString()) return;
                model.handleChange(n, v);
                model.refresh();
              }}
            />
          )}
          <DatePickerField
            template={'6'}
            icontype={2}
            minDate={moment()}
            style={{ minWidth: remCss(200), flex: 0 }}
            placeholder={LANG_CONST.select_date}
            placement={'bottom-end'}
            name={'date'}
            value={model.input('date')}
            onChange={(n, v) => {
              if (v.toString() === model.input('date').toString()) return;
              if (!v) v = moment();
              model.handleChange('date', v);
              model.refresh();
            }}
            invalid={{}}
          />
          <MCButton
            primary
            medium
            light
            radius
            style={{ height: remCss(50) }}
            // test='foo'
            onClick={() => {
              model.setState({ date: moment(model.state.date).add(1, 'day') });
              model.refresh();
            }}
          >
            {lang.t(LANG_CONST.buttons.next)}
          </MCButton>
        </div>
      </div>
    </>
  );
};
class Doctor extends BaseComponent {
  state = { size: 2 };

  componentDidMount() {
    model.subscribe(this.subscription);
    // model.refreshRecent();
  }

  componentWillUnmount() {
    model.unsubscribe(this.subscription);
  }

  openDoctor = (doctor, slot) => {
    if (slot && model.state.user?.isDoctor) return;
    model.emit('openDoctor', doctor);
    let url = permissions.PAGES.DOCTORS_DETAIL_PAGE.match(doctor.username);
    if (slot) url += '/book';
    this.props.router.navigate(url, { state: { slot } });
  };

  render() {
    const list = model.items();
    const loading = model.refreshing();
    let searchQuery = model.listInput('search');
    const customList = [];
    const { size } = this.state;
    let specialist = model.getState().specialist;
    if (specialist.length > 0 || searchQuery.toString().length > 2)
      for (let i = 0; i < list.length; i += size) {
        let row = list.slice(i, i + size);
        if (row.length < size) {
          for (let j = row.length; j < size; j++) {
            row.push({ id: i + '_' + j, temp: true });
          }
        }
        customList.push(row);
      }

    return (
      <div className={'mc-container-content mc-discovery'}>
        <Virtuoso
          className={'mc-virtuoso-list'}
          components={{
            Header,
            Footer: () => {
              if (specialist.length === 0 && searchQuery.toString().length < 3) return null;
              return (
                <>
                  {!customList.length && !loading && !model.searchTimeout && (
                    <div className={'mc-doctor-box-row'}>
                      <div className={'mc-doctor-box not-found'}>
                        <img src={NotFoundDoctor} alt={''} width={remCss(103)} />
                        <pre className={'mc-title'}>
                          {lang.t(LANG_CONST.text.discovery_not_found)}
                        </pre>
                      </div>
                    </div>
                  )}
                  {loading && (
                    <Spinner
                      containerStyles={{
                        padding: !model.loadingMore ? remCss(150) : 'auto'
                      }}
                    />
                  )}
                </>
              );
            }
          }}
          data={!loading || model.loadingMore ? customList : []}
          endReached={() => {
            if (!loading && model.hasMore()) {
              model.loadMore();
            }
          }}
          itemContent={(i, items) => {
            return (
              <div className={'mc-doctor-box-row'} key={'mc-doctor-list-item-' + i}>
                {items.map((item) => (
                  <DoctorItem
                    key={'mc-doctor-box-' + item.id}
                    doctor={item}
                    {...item}
                    slotsLength={item && item.slots && item.slots.length}
                    onOpenDoctor={this.openDoctor}
                  />
                ))}
              </div>
            );
          }}
        />
      </div>
    );
  }
}

export default withRouter(Doctor);
